export default __webpack_public_path__ + "static/media/envelope.f28cd3e3.svg";